import clsx from 'clsx';
import React, { useContext } from 'react';
import { BoxContext } from './Context';
import { getBackgroundForVariant } from './utils';

export const CommonSeparator: React.FC<React.PropsWithChildren<{ line: React.ReactNode }>> = ({
  line,
  children,
}) => {
  const { variant } = useContext(BoxContext);

  return (
    <div
      aria-hidden={React.Children.count(children) > 0 ? 'false' : 'true'}
      className={'relative flex w-full justify-center text-black'}
      role="separator"
    >
      {line}
      {children && (
        <div
          className={clsx(
            'absolute top-0 mx-auto -translate-y-1/2 px-2 py-0',
            `${getBackgroundForVariant(variant)}`
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
};
